import React from "react";
import { H2, P, InputContainer, LabelContainer } from "../../styles";
import Button from "../../components/Button/Button";
import { useTranslation } from "react-i18next";
import NvidiaContainer from "../../hoc/NvidiaContainer";
import { ButtonsContainer } from "../../components/Button/styles";
const Gfe = ({ enrolled, locale }) => {
  const { t } = useTranslation();
  const ctaConfig = {
    main: {
      label: enrolled ? t("Download") : t("Enroll"),
      onClick: () => {
        if (enrolled) {
          location.href = `${
            locale !== "zh-cn" ? "/" + locale : ""
          }${GFE_DOWNLOAD_URL}`;
        } else {
          location.href = `${
            locale !== "zh-cn" ? "/" + locale : ""
          }${GFE_REWARDS_URL}`;
        }
      },
    },
    secondary: {
      label: enrolled ? t("Open GeForce Experience") : t("Download"),
      onClick: () => {
        if (enrolled) {
          location.href = GFE_OPENER;
        } else {
          location.href = `${
            locale !== "zh-cn" ? "/" + locale : ""
          }${GFE_DOWNLOAD_URL}`;
        }
      },
    },
  };
  return (
    <NvidiaContainer>
      <H2>{t("GeForce Rewards")}</H2>

      <P>
        {!enrolled
          ? t("Sign up to access rewards and giveaways")
          : t(
              "Download or open the GeForce Experience app to check for available rewards."
            )}
      </P>

      <ButtonsContainer>
        <Button
          label={ctaConfig.main.label}
          clickHandler={ctaConfig.main.onClick}
        />
        <Button
          label={ctaConfig.secondary.label}
          clickHandler={ctaConfig.secondary.onClick}
          theme="alt"
        />
      </ButtonsContainer>
    </NvidiaContainer>
  );
};
export default Gfe;
